/* src/app/admin/roleprofile-list/roleprofile-list.component.scss */
/*# sourceMappingURL=roleprofile-list.component-WGVZTEZ2.css.map */
